import React, { useState, useEffect, useMemo } from "react";
import { FloatingActionBar } from "@lsq/nextgen/v2/floating-action-bar";
import Icon from "../../dashboard/Icon/Icon";
import { onFormClick } from "../../utils/helper";
import { apiGetWebLaunchBar } from "../../network/api";

const LaunchBar = () => {
  const [launchBarConfig, setLaunchBarConfig] = useState([]);
  const [draggable, setDraggable] = useState(false);

  useEffect(() => {
    const fetchLaunchBarData = async () => {
      const initialDashboardData = await apiGetWebLaunchBar();
      setLaunchBarConfig(initialDashboardData?.config || []);
    };
    fetchLaunchBarData();
  }, []);

  // react-draggable@4.6.0 calls findDOMNode on drag-start, which returns null
  // if the bar isn't mounted yet. Enable dragging only after mount so the
  // DraggableCore node ref is stable before any drag gesture begins.
  useEffect(() => {
    setDraggable(true);
  }, []);

  const actions = useMemo(
    () =>
      launchBarConfig.map((item) => ({
        label: item.displayName,
        value: `${item.id ?? item.displayName}`,
        onSelect: () => onFormClick(item),
        icon: (
          <Icon
            src={`images/outlined/${item?.icon?.imgName || "lsq_copy"}.svg`}
            alt={item.displayName}
            isWidgetIcon={false}
            title={item.displayName}
            draggable="false"
            style={{ filter: "brightness(0) invert(1)" }}
          />
        ),
      })),
    [launchBarConfig]
  );

  if (launchBarConfig.length === 0) return;

  return <FloatingActionBar draggable={draggable} actions={actions} />;
};

export default LaunchBar;
